import { jwtDecode } from "jwt-decode";
import { fetchWithAuthJson, fetchWithAuth } from "../context/FetchWithAuth";
import { baseUrl } from "../utils/config";


// ---------------------------------api bridge--------------------------------------------------
// #region
export const getAllBridge = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllBridge`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveBridge = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addBridge`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editBridge = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateBridge`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteBridge = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteBridge?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api application TPE-----------------------------------------
// #region
export const getAllApplciationTPE = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllTPE`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveApplciationTPE = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addTpe`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editApplciationTPE = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateTpe`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteApplciationTPE = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteAppl?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api device--------------------------------------------------
// #region
export const getAllDevice = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllDevice`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveDevice = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addDevice`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editDevice = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateDevice`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteDevice = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteDevice?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api device base---------------------------------------------
// #region
export const getAllDeviceBase = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllDeviceBase`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveDeviceBase = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addDeviceBase`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editDeviceBase = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateDeviceBase`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteDeviceBase = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteDeviceBase?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api device pinpad-------------------------------------------
// #region
export const getAllDevicePinpad = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllDevicePinpad`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveDevicePinpad = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addDevicePinpad`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editDevicePinpad = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateDevicePinpad`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteDevicePinpad = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteDevicePinpad?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api sim type------------------------------------------------
// #region
export const getAllSimType = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllSimTypePagination`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveSimType = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addSimType`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editSimType = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateSimType`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteSim = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteSim?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api solution code-------------------------------------------
// #region
export const getAllSolutionCode = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllSolutionCode`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveSolutionCode = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addSolutionCode`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editSolutionCode = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateSolutionCode`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteSolutionCode = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteSolutionCode?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api error code----------------------------------------------
// #region
export const getAllErrorCode = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllErrorCode`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveErrorCode = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addErrorCode`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editErrorCode = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateErrorCode`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteErrorCode = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteErrorCode?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api serial part code----------------------------------------
// #region
export const getAllSerialPart = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllSerialPart`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveSerialPart = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addSerialPart`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editSerialPart = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateSerialPart`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteSerialPart = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteSerialPart?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api groupe--------------------------------------------------
// #region
export const getAllGroup = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllGroupe`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveGroup = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addUserGroup`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const saveActive = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateActiveMessage`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const saveSondage = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateActiveSondage`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editGroup = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateGroup`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editNameGroup = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateGroupName`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteGroup = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteGroup?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getGroup = async (ids: string[]) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/getGroupe?ids=${ids.map(id => encodeURIComponent(id)).join('&ids=')}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getAdminGroups = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/getAdminGroups`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getAdminGroupConfigs = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/getAdminGroupConfigs`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveMsgGroup = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addMsgGroup`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const saveIsSondage = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateActiveSondage`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const saveIsDom = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateActiveDom`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const saveIsActive = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateActiveMessage`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const getMsgGroup = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/getMsgGroup?id=${encodeURIComponent(id)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------api utilisateur---------------------------------------------
// #region
export const getAllUser = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/findAllUser`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getAllUserByRole = async (role: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/findAllUserByRole?role=${encodeURIComponent(role)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const getAllUserByGroup = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/findAllUserByGroupe?id=${encodeURIComponent(id)}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveUser = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const decodedToken: any = jwtDecode(token);
        const addField = (data: { [key: string]: any }) => {
            return {
                ...data,
                adminMail: decodedToken.sub
            };
        };

        const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/adduser`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(addField(data))
        });

        return response;
    }
}

export const saveUserTec = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const decodedToken: any = jwtDecode(token);
        const addField = (data: { [key: string]: any }) => {
            return {
                ...data,
                adminMail: decodedToken.sub
            };
        };

        const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/adduserTec`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(addField(data))
        });

        return response;
    }
}

export const editUser = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/updateUser`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editUserGroup = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/updateUserGroup`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteUser = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/v1/user/deleteUser?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const updatPwdUser = {
    post: async (password: string, currentPassword: string) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");

        const response = await fetchWithAuth(`${baseUrl}/app_api/update-password`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ token, password, currentPassword })
        });

        return response;
    }
}
// #endregion

// ---------------------------------gestion mailling--------------------------------------------
// #region
export const getAllMail = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllMail`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveMail = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addMail`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editMail = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateMail`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteMail = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteMail?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion

// ---------------------------------gestion repartition RI--------------------------------------------
// #region
export const getAllGroupRI = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/findAllGroupRI`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}

export const saveGroupRI = {
    post: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/addGroupRI`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const editGroupRI = {
    put: async (data: any) => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token expirer");
        const response = await fetchWithAuthJson(`${baseUrl}/app_api/updateGroupRI`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });

        return response;
    }
}

export const deleteGroupRI = async (id: string) => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token expirer");
    const response = await fetchWithAuthJson(`${baseUrl}/app_api/deleteGroupRI?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
    });

    return response;
}
// #endregion
